import { FC } from 'react'
import useMessenger from '@/hooks/useMessenger'

import { StoreContext } from '@/context/context'
import { StoreContextType } from '@/context/types'

import './styles.css'

export interface LoadingProps {
  noMessage?: boolean
  context?: React.Context<StoreContextType | null>
}

const Loading: FC<LoadingProps> = ({ noMessage, context = StoreContext }) => {
  const { introMessage } = useMessenger(context)
  return (
    <div className="pmui-flex pmui-flex-col pmui-justify-center pmui-items-center pmui-h-full">
      <div className="loading-indicator pmui-h-10 pmui-w-10 pmui-animate-spin" />
      {!noMessage && (
        <pre className="pmui-font-eina03 pmui-font-semibold pmui-pt-2 pmui-text-sm pmui-text-center">
          {introMessage}
        </pre>
      )}
    </div>
  )
}

export default Loading
